// 기본 clamp 계산 함수
export function getResponsiveClamp(
    minPx: number,
    maxPx: number,
    minWidth = 320,
    maxWidth = 1920
): string {
    const slope = (maxPx - minPx) / (maxWidth - minWidth);
    const intercept = minPx - slope * minWidth;
    return `clamp(${minPx}px, ${slope * 100}vw + ${intercept}px, ${maxPx}px)`;
}

// 폰트
export const responsiveFont = (min: number, max: number): string =>
    getResponsiveClamp(min, max);

// 수직 패딩
export const responsivePaddingVertical = (min: number, max: number): string =>
    getResponsiveClamp(min, max);

// 수평 패딩 
export const HorizontalPadding = (min: number, max: number): string => 
    getResponsiveClamp(min, max);

// 수평 패딩 (1920px 이상일 때 패딩 증가)
export const responsivePaddingHorizontal = (minPx: number, maxPx: number): string => {
    const clampValue = getResponsiveClamp(minPx, maxPx);
    const beyond1920 = `calc((100vw - 1920px) / 2 + ${minPx / 2}px)`;
    return `max(${clampValue}, ${beyond1920})`;
};

// 이미지 & 아이콘
export const responsiveImageSize = (minPx: number, maxPx: number): string =>
    getResponsiveClamp(minPx, maxPx);


